<h2 mat-dialog-title>{{'operations.choose_geofence_type' | transloco}}</h2>
<mat-dialog-content>
  <div class="shape-list">
    @for (shape of shapes; track shape; let i = $index) {
      <button type="button"
              class="shape-option pt-1"
              [ngClass]="{'primary-background text-white': selectedShape === i,
                          'vertical-list': isHandset}"
              (click)="selectShape(i)">
        <img [src]="shape.img" [ngClass]="{'selected-type': selectedShape === i}" alt="Shape"/>
        <p [ngClass]="{'font-weight-bold': selectedShape === i}">{{shape.label | transloco}}</p>
      </button>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{'operations.cancel' | transloco}}</button>
  <button [disabled]="selectedShape === undefined" mat-button color="primary" [mat-dialog-close]="true" (click)="save()">
    {{'operations.add' | transloco}}
  </button>
</mat-dialog-actions>
